import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { animated, useSpring } from "react-spring";
import { SwipeableHandlers, useSwipeable } from "react-swipeable";
import { Captain } from "../../../types/Captain";
import CaptainBanner from "../CaptainBanner/CaptainBanner";
import { captainCardContainer } from "./captainCardStyles";

interface CaptainCardProps {
    captain: Captain;
    triggerBanner: boolean;
}

const CaptainCard: React.FC<CaptainCardProps> = ({
    captain,
    triggerBanner,
}) => {
    const navigate = useNavigate();
    const [cardHeight, setCardHeight] = useState("100vh");
    const [backgroundSize, setBackgroundSize] = useState("cover");

    const zoomProps = useSpring({
        from: { transform: "scale(1.2)" },
        to: { transform: "scale(1)" },
        config: { duration: 2000 },
        reset: true,
    });

    const adjustDimensions = () => {
        setCardHeight(`${window.innerHeight}px`);
        setBackgroundSize(
            window.innerWidth > window.innerHeight ? "contain" : "cover"
        );
    };

    useEffect(() => {
        adjustDimensions();
        window.addEventListener("resize", adjustDimensions);

        return () => {
            window.removeEventListener("resize", adjustDimensions);
        };
    }, []);

    const handleClick = () => {
        navigate(`${captain.route}/statistics`);
    };

    const swipeHandlers: SwipeableHandlers = useSwipeable({
        onSwipedLeft: () => {
            navigate(captain.route);
        },
        trackMouse: true,
    });

    return (
        <Box
            {...swipeHandlers}
            onClick={handleClick}
            sx={captainCardContainer(cardHeight)}
        >
            <animated.div
                style={{
                    ...zoomProps,
                    backgroundImage: `url(${captain.imageUrl})`,
                    backgroundPosition: "center",
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    backgroundSize: backgroundSize,
                    backgroundRepeat: "no-repeat",
                }}
            />
            <CaptainBanner captain={captain} triggerBanner={triggerBanner} />
        </Box>
    );
};

export default CaptainCard;
